import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/practice";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/practice")(
  enRouteOptions(routeOptions, {
    svPath: "/practice",
    title: 'Alcohol License Sweden – Practice Test in English',
    description: 'Practice for the Swedish alcohol license test (kunskapsprov) in English. Real question types, instant explanations, all topics, updated for the 2026 law.',

    ogImage: "https://alkoholprovet.se/og/default.jpg",
    noindex: false,
  }),
);
